export const defaultApolloCache = {
  ROOT_QUERY: {
    __typename: "Query",
  },
  ApplicationParams: {
    __typename: "ApplicationParams",
  },
  ApplicationLoader: {
    __typename: "ApplicationLoader",
  },
};
